import { AppConfig } from './app-config';

/**
 * AppConfig drawn from window global variables.
 */
export class AppConfigFromWindowContext extends AppConfig {
  constructor(windowConfig: AppConfig) {
    super();

    this.apiEndpoint = windowConfig.apiEndpoint;
    this.beta = windowConfig.beta;
    this.error = windowConfig.error;
    this.isEmbeddedMode = windowConfig.isEmbeddedMode;
    this.ltiRelinkUrl = windowConfig.ltiRelinkUrl;
    this.personaEndpoint = windowConfig.personaEndpoint;
    this.talisLoginProvider = windowConfig.talisLoginProvider;
    this.zendeskOutboundKey = windowConfig.zendeskOutboundKey;
    this.tenant = windowConfig.tenant;
  }
}
